import * as React from 'react';
import {Dialog, DialogContent} from '@mui/material'
import HeatMap from '../HeatMap/HeatMap';
import { TransitionProps } from '@mui/material/transitions';
import Slide from '@mui/material/Slide';


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction='up' ref={ref} {...props} />;
});


const MapPopup = (props: any) => {

    return (
        <React.Fragment>
            <Dialog
                PaperProps={{
                    sx: {
                        maxHeight: '90%',
                        minHeight: '90%',
                        minWidth: '90%',
                        maxWidth: '90%',
                        overflow: 'hidden',
                    }
                }}
                onClose={props.close}
                open={props.open}
                className='heatmap-dialog'
                TransitionComponent={Transition}
            >
                <DialogContent className='heatmap-dialog-content'>
                    <HeatMap displayedRecords={'All'} dialog={true}/>
                </DialogContent>

            </Dialog>
        </React.Fragment>
    );
};

export default MapPopup;